import { render } from "./ChatPanel.vue?vue&type=template&id=3628f422&scoped=true&lang=pug"
import script from "./ChatPanel.js?vue&type=script&lang=js&external"
export * from "./ChatPanel.js?vue&type=script&lang=js&external"

import "./ChatPanel.vue?vue&type=style&index=0&id=3628f422&lang=scss&scoped=true"
import "./ChatPanel.vue?vue&type=style&index=1&id=3628f422&lang=scss"
import "./ChatPanel.vue?vue&type=style&index=2&id=3628f422&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3628f422"]])

export default __exports__